import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {getImage} from '../../assets/images/index';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <img
            src={getImage('logoPrefeitura')}
            alt="Logo 1"
            className="logo-image"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <img
            src={getImage('logoSaaeFundoBranco')}
            alt="Logo 2"
            className="logo-image"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <img
            src={getImage('logoFtsPreta')}
            alt="Logo 3"
            className="logo-image"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
        <div className="navbar-menu">
          <Link to="/" className={`navbar-link ${isActive('/')}`}>
            Home
          </Link>
          <Link to="/pesquisas" className={`navbar-link ${isActive('/pesquisas')}`}>
            Pesquisas
          </Link>
          <Link to="/documentos" className={`navbar-link ${isActive('/documentos')}`}>
            Documentos
          </Link>
          <Link to="/noticias" className={`navbar-link ${isActive('/noticias')}`}>
            Notícias
          </Link>
          <Link to="/sobre" className={`navbar-link ${isActive('/sobre')}`}>
            Sobre Nós
          </Link>
          <Link to="/contato" className={`navbar-link ${isActive('/contato')}`}>
            Contato
          </Link>
        </div>

        <div className="navbar-toggle" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
      <div className={`navbar-mobile ${isMenuOpen ? 'active' : ''}`}>
        <Link to="/" className={`navbar-mobile-link ${isActive('/')}`} onClick={toggleMenu}>
          Home
        </Link>
        <Link to="/pesquisas" className={`navbar-mobile-link ${isActive('/pesquisas')}`} onClick={toggleMenu}>
          Pesquisas
        </Link>
        <Link to="/documentos" className={`navbar-mobile-link ${isActive('/documentos')}`} onClick={toggleMenu}>
          Documentos
        </Link>
        <Link to="/noticias" className={`navbar-mobile-link ${isActive('/noticias')}`} onClick={toggleMenu}>
          Notícias
        </Link>
        <Link to="/sobre" className={`navbar-mobile-link ${isActive('/sobre')}`} onClick={toggleMenu}>
          Sobre Nós
        </Link>
        <Link to="/contato" className={`navbar-mobile-link ${isActive('/contato')}`} onClick={toggleMenu}>
          Contato
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
